import { DhlDropdown } from "@dhl-official/react-library";
import styled from "styled-components";

/**
 * `DhlDropdown` customisation to render validation feedback icon within the dropdown.
 */
export const Dropdown = styled(DhlDropdown)({
  position: "relative",

  "& .dropdown-container .options-container": {
    zIndex: 10,
  },

  "& dhl-validation-feedback-icon": {
    margin: 0,
    position: "absolute",
    right: 0,
    top: 0,

    "& .dhl-validation-feedback-icon": {
      margin: 0,
      position: "relative",
      right: "2.5em",
      top: "1.2em",

      "@media screen and (min-width: 48rem)": {
        right: "2.9em",
      },
    },
  },
});

export const DropdownWrapper = styled.div`
  display: ${({ hasShowPostalcodeField }) =>
    hasShowPostalcodeField ? "block" : "none"};
`;
